import { useState } from 'react'
import axiosInstant from '../../../api'
import { removeBrandTeamEndpoint } from '../../../api/endpoints'

// interface AddBrandTeamPayload {
//     user_emails?: string[];
//     user_ids?: number[];
// }

export const useRemoveBrandTeam = (brandId: number) => {
  const [loading, setLoading] = useState(false)

  const removeFromBrandTeam = async (userId: string) => {
    setLoading(true)
    try {
      const response = await axiosInstant.delete(removeBrandTeamEndpoint(brandId.toString(), userId))
      const { status, data } = response
      if (status === 200) {
        setLoading(false)
        return data.updated
      }
      return response
    } catch (error) {
      return Promise.reject(error)
    }
  }

  return {
    loading,
    removeFromBrandTeam,
  }
}
